import { render, staticRenderFns } from "./RtmpProperty.vue?vue&type=template&id=40b7c1eb&"
import script from "./RtmpProperty.vue?vue&type=script&lang=js&"
export * from "./RtmpProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports